// CSS:
// 1、公共部分
import "../public/css/global.css";
import "../public/css/commonHead.css";
import "../public/css/messageDialogBox.css";
import "../public/css/dataEditModal.css";
// 20251028：signupAndLogin.ejs 页面不再做为单独访问页面管理
import "../public/css/signupAndLogin.css";
import "../public/css/commonFooter.css";
// 2、独有部分
import "../public/css/exhibition.css";
import "../public/css/checkoutModal.css";
// 有 checkoutModal 的宿主页面中，就有scanToPay<跟随checkoutModal>，就需要 scanToPay.css
import "../public/css/scanToPay.css";
import "../public/css/dataEditModal.css";   // 20250830 改到 commonHead 模块中统一全局集成了 -> 取消了 commonHead 入口
import "../public/css/order.css";
// import "../public/css/accountRecharge.css"; // 作为完整 html 文件管理了 —— 需要的页面引入该页面即可

// JS:
// 1、公共部分
import '../public/js/common/appVariables.js';  // 20260905 Add，要优先于 indexedDBManager.js
// 20251119：只需在 commonHead 入口中包含即可，其它入口不需要再包含！-> 
// 20260420 取消 commonHead 入口，改为自己 SPA 页面自己管理
import '../public/js/common/pagesMessageBus.js';  // 这是基础设施，优先加载初始化！

import '../public/js/common/mountGlobalObjects.js';
import '../public/js/common/axiosInterceptor.js';  // 20260905 Add

import '../public/js/commonHead.js';
import '../public/js/messageDialogBox.js';
import '../public/js/common/clickFlame.js';
import '../public/js/dataEditModal.js'
import '../public/js/common/pagaDataLifeCycleManager.js'  // 20260420
import '../public/js/common/indexedDBManager.js';  // 20260420
// 20251028：signupAndLogin.ejs 页面不再做为单独入口页面管理
import '../public/js/signupAndLogin.js';
// 开发阶段不引用该脚本，正式上线时测试后引入
// import '../public/js/commonFooter.js';
// 2、独有部分，顺序很重要，有依赖关系
import '../public/js/socialInteraction.js';
// import '../public/js/checkoutModal.js';   // 20260727 改为对应页面的 js 模块内引入
import '../public/js/exhibition.js';
import '../public/js/cart.js';
// // order 模块只有个人中心页面中存在
// import '../public/js/order.js';
import '../public/js/common/editTableCell.js';
// import '../public/js/accountRecharge.js';  // // 作为完整 html 文件管理了 —— 需要的页面引入该页面即可
